// extracted by mini-css-extract-plugin
module.exports = {"pointer":"Tabs_pointer__1dxnj","tabs":"Tabs_tabs__s5m4X","tab":"Tabs_tab__1bcr7","tabText":"Tabs_tabText__1wtCI","icon":"Tabs_icon__1Ke6F","active":"Tabs_active__3g2qW"};